import React from "react";

import { ListItemText as MUIListItemText } from "@mui/material";

const ListItemText = ({ item }) => {
  const title = `${item.code}`
  const secondary = `${item.description} - ${item.points}pts`

  return (
    <MUIListItemText
      primary={title || "null"}
      secondary={secondary || "null"}
    />
  );
};

export default ListItemText;